import React from "react";
import Container from "./Container";

export default function Section({
  children,
  className = "",
  containerClassName = "",
  containerSize = "default",
  id,
}: {
  children: React.ReactNode;
  className?: string;
  containerClassName?: string;
  containerSize?: "default" | "narrow" | "wide";
  id?: string;
}) {
  return (
    <section id={id} className={`relative py-20 sm:py-28 ${className}`}>
      <Container className={containerClassName} size={containerSize}>
        {children}
      </Container>
    </section>
  );
}

export function SectionHeader({
  eyebrow,
  title,
  description,
  align = "center",
  className = "",
  as: Component = "h2",
}: {
  eyebrow?: string;
  title: React.ReactNode;
  description?: React.ReactNode;
  align?: "left" | "center";
  className?: string;
  as?: "h1" | "h2";
}) {
  const isCenter = align === "center";
  return (
    <div
      className={`${isCenter ? "mx-auto text-center" : "text-left"} max-w-3xl ${className}`}
    >
      {eyebrow && (
        <div
          className={`inline-flex items-center gap-2 rounded-full border border-copper-700/40 bg-copper-900/20 px-3 py-1 text-[11px] font-medium uppercase tracking-[0.18em] text-copper-300`}
        >
          <span className="h-1.5 w-1.5 rounded-full bg-copper-400 shadow-[0_0_8px_rgba(208,129,74,0.8)]" />
          {eyebrow}
        </div>
      )}
      <Component className="mt-5 font-display text-3xl font-bold tracking-tight text-white sm:text-4xl md:text-5xl">
        {title}
      </Component>
      {description && (
        <p className="mt-5 text-base leading-relaxed text-zinc-400 sm:text-lg">
          {description}
        </p>
      )}
    </div>
  );
}
